import { Platform } from '@testsigmainc/constants';
import classNames from 'classnames';
import { Icon, ToolTip } from '@testsigma/atoms';

interface MobileDeviceTypeProps {
  deviceName?: string;
  deviceTitle?: string;
  deviceOs: string;
  isRealDevice: boolean;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: any;
}

export const MobileDeviceType: React.FC<MobileDeviceTypeProps> = ({
  deviceName,
  deviceTitle,
  deviceOs,
  isRealDevice,
  className,
  variant = 'concise',
  tooltipPlacement,
}) => {
  const iconName = isRealDevice
    ? 'real-mobile'
    : deviceOs === Platform.iOS
    ? 'simulator'
    : 'emulator';

  const displayName = deviceName || deviceTitle || '';
  return (
    <ToolTip placement={tooltipPlacement} content={displayName} align='center'>
      <span className={classNames('flex flex-row items-center', className)}>
        <Icon
          className={classNames(
            'text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-base',
            {
              'leading-5': variant === 'concise',
            },
          )}
          name={iconName}
        ></Icon>
        {variant === 'detail' && (
          <span className='ml-2 truncate'>{displayName}</span>
        )}
      </span>
    </ToolTip>
  );
};
